import { create } from 'zustand';

export enum _Bool {
    true = 'true',
    false = 'false',
}

export type FileStore = { name: string; size: number; type: string; content: string | ArrayBuffer | null };

type State = {
    email: string;
    bank: string;
    since: string;
    oldestTransactionDate: string;
    sessionWarning: _Bool;
    allowCredentials: _Bool;
    allowTesting: _Bool;
    twoFaAvailable: _Bool;
    twoFaAvailableTransaction: _Bool;
    twoFaList: string;
    captchaDetection: _Bool;
    note: string;
    fileStore: FileStore[];
    fileReplaceStore: string[];
    setEmail: (value: string) => void;
    setBank: (value: string) => void;
    setSince: (value: string) => void;
    setOldestTransactionDate: (value: string) => void;
    setSessionWarning: (value: _Bool) => void;
    setAllowCredentials: (value: _Bool) => void;
    setAllowTesting: (value: _Bool) => void;
    setTwoFaAvailable: (value: _Bool) => void;
    setTwoFaAvailableTransaction: (value: _Bool) => void;
    setTwoList: (value: string) => void;
    setCaptchaDetection: (value: _Bool) => void;
    setNote: (value: string) => void;
    setFileStore: (value: FileStore[]) => void;
    setFileReplaceStore: (value: string[]) => void;
};

export const useStore = create<State>((set) => ({
    email: '',
    bank: '',
    since: '',
    oldestTransactionDate: '',
    sessionWarning: _Bool.false,
    allowCredentials: _Bool.false,
    allowTesting: _Bool.false,
    twoFaAvailable: _Bool.false,
    twoFaAvailableTransaction: _Bool.false,
    captchaDetection: _Bool.false,
    twoFaList: '',
    note: '',
    fileStore: [],
    fileReplaceStore: [''],
    setEmail: (email: string) => set(() => ({ email })),
    setBank: (bank: string) => set(() => ({ bank })),
    setSince: (since: string) => set(() => ({ since })),
    setOldestTransactionDate: (oldestTransactionDate: string) => set(() => ({ oldestTransactionDate })),
    setSessionWarning: (sessionWarning: _Bool) => set(() => ({ sessionWarning })),
    setAllowCredentials: (allowCredentials: _Bool) => set(() => ({ allowCredentials })),
    setAllowTesting: (allowTesting: _Bool) => set(() => ({ allowTesting })),
    setTwoFaAvailable: (twoFaAvailable: _Bool) => set(() => ({ twoFaAvailable })),
    setTwoFaAvailableTransaction: (twoFaAvailableTransaction: _Bool) => set(() => ({ twoFaAvailableTransaction })),
    setCaptchaDetection: (captchaDetection: _Bool) => set(() => ({ captchaDetection })),
    setTwoList: (twoFaList: string) => set(() => ({ twoFaList })),
    setNote: (note: string) => set(() => ({ note })),
    setFileStore: (fileStore: FileStore[]) => set(() => ({ fileStore })),
    setFileReplaceStore: (fileReplaceStore: string[]) => set(() => ({ fileReplaceStore })),
}));
